export default {
  email: 'Correo'
};
